module.exports = __webpack_public_path__ + "static/media/IMG_8793.1d1d9f0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8793.jpg
// module id = 153
// module chunks = 0